import React, {useState} from "react";
import {BoxIsolatedContent, ContentTop16, FlexColumnCentered} from "../../../components/ui/Content";
import {Caption2, FormTitle} from "../../../components/Font";
import {useTranslation} from "react-i18next";
import {InputAutoCompleteEnum, InputElement, InputTypeEnum} from "../../../ui/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {RegisterInputContainer} from "../../../components/ui/InputSearch";
import {ButtonPrimary} from "../../../components/ui/Button";
import {cleanError, UpdatePassword} from "../slice";
import {RecoveryStepEnum} from "../../../enum/auth";
import {PasswordSavingModal} from "./PasswordSavingModal";
import {setGlobalAlert} from "../../Alert/slice";
import {AlertType} from "../../../components/ui/Alert";
import {useLocation, useNavigate} from "react-router-dom";

export const CreateNewPassword = () => {

    const dispatch = useAppDispatch()
    const {t} = useTranslation()
    const navigate = useNavigate()
    const {search} = useLocation()
    const {error, recoveryStep} = useAppSelector((state) => state.auth)

    const [passwords, setPasswords] = useState({
        password: '',
        password_repeat: ''
    })
    const selectedUser = localStorage.getItem('selectedUser')
    const submit = () => {
        const token = localStorage.getItem('recoveryToken')
        const recoveryPhone = localStorage.getItem('recoveryPhone')
        if (token) {
            dispatch(UpdatePassword({
                token,
                password: passwords.password,
                password_repeat: passwords.password_repeat,
                ad_person_id: Number(selectedUser),
                phone: recoveryPhone
            })).then(res => {
                if (res.type.includes('fulfilled')) {
                    dispatch(setGlobalAlert(
                        {
                            message: t('auth.passwordSaveSuccess'),
                            type: AlertType.Success
                        }))
                    navigate(`/sign-in${search}`)
                }
            })
        }
    }

    return <>
        {recoveryStep === RecoveryStepEnum.PasswordSaving && <PasswordSavingModal/>}
        <FlexColumnCentered className={'box-isolated'}
                            filter={recoveryStep === RecoveryStepEnum.PasswordSaving ? 'blur(3.5px)' : 'none'}>
            <BoxIsolatedContent>
                <FlexColumnCentered style={{width: '100%'}}>
                    <FormTitle>{t('auth.passwordRecovery')}</FormTitle>
                </FlexColumnCentered>

                <ContentTop16>
                    <Caption2>
                        {t('auth.passwordRules')}
                    </Caption2>
                </ContentTop16>

                <RegisterInputContainer>
                    <InputElement
                        autofocus={true}
                        placeholder={t('auth.password')}
                        error={error['password']}
                        type={InputTypeEnum.Password}
                        value={passwords.password}
                        onChange={value => {
                            setPasswords({...passwords, password: value})
                            if (error['password']) {
                                dispatch(cleanError('password'))
                            }
                        }}
                        autoComplete={InputAutoCompleteEnum.NewPassword}
                    />
                </RegisterInputContainer>

                <RegisterInputContainer>
                    <InputElement
                        placeholder={t('auth.repeatPassword')}
                        type={InputTypeEnum.Password}
                        error={error['password_repeat']}
                        value={passwords.password_repeat}
                        onChange={value => {
                            setPasswords({...passwords, password_repeat: value})
                            if (error['password_repeat']) {
                                dispatch(cleanError('password_repeat'))
                            }
                        }}
                        onKeyDown={(key) => {
                            if (key === 'Enter' && passwords.password === passwords.password_repeat && passwords.password.length >= 6) {
                                submit()
                            }
                        }}
                        autoComplete={InputAutoCompleteEnum.NewPassword}
                    />
                </RegisterInputContainer>

                <ButtonPrimary
                    disabled={passwords.password !== passwords.password_repeat || passwords.password.length < 6}
                    onClick={submit}>
                    {t('auth.save')}
                </ButtonPrimary>
            </BoxIsolatedContent>
        </FlexColumnCentered>
    </>
}
